import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import "./messages.css";

// will display 2 2-column image text message
export default function Messages() {
  const { isLoggedIn } = useSelector((state) => state.user);

  return (
    <div className="messages">
      <div className="row messsage message-1">
        <div className="col-xs-12 col-md-12 col-lg-6 imgcontainer">
          <img src="/assets/message1.png" alt="message" />
        </div>
        <div className="col-xs-12 col-md-12 col-lg-6 message__column">
          <div className="message__column__wrapper">
            <h4 className="message-title"> Get Inspired </h4>
            <p className="message-text">With thousands of professional templates, images and quality content to choose from, get a head start on bringing your best ideas and work to life.</p>
            <Link to="/design"
            // target={isLoggedIn ? "" : "_blank"}
            >
              <button className="btn-primary message-btn">Start Creating</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="row messsage message-2">
        <div className="col-xs-12 col-md-12 col-lg-6 imgcontainer">
          <img src="/assets/message2.png" alt="message" />
        </div>
        <div className="col-xs-12 col-md-12 col-lg-6 message__column">
          <div className="message__column__wrapper">
            <h4 className="message-title">
              Create & Share
            </h4>
            <p className="message-text">
              With thousands of professional templates, images and quality content to choose from, get a head start on bringing your best ideas and work to life.
            </p>
            <Link to="/design"
            // target={isLoggedIn ? "" : "_blank"}
            >
              <button className="btn-primary message-btn">Start Creating</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
